"use strict";

exports.__esModule = true;
exports.default = void 0;
const startHeartbeat = {
  type: 'startHeartbeat'
};
const stopHeartbeat = {
  type: 'stopHeartbeat'
};
const resetHeartbeat = {
  type: 'resetHeartbeat'
};
const setUtmParameters = {
  type: 'setUtmParameters'
};
const clearUtmParameters = {
  type: 'clearUtmParameters'
};
const cleanUpEnrichedParameters = {
  type: 'cleanUpEnrichedParameters'
};

const enrich = data => ({
  type: 'enrich',
  data
});

var _default = {
  startHeartbeat,
  stopHeartbeat,
  resetHeartbeat,
  setUtmParameters,
  clearUtmParameters,
  cleanUpEnrichedParameters,
  enrich
};
exports.default = _default;